import { render } from "./stageShow.vue?vue&type=template&id=1fb0bdc1&scoped=true"
import script from "./stageShow.vue?vue&type=script&lang=js"
export * from "./stageShow.vue?vue&type=script&lang=js"

import "./stageShow.vue?vue&type=style&index=0&id=1fb0bdc1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb0bdc1"]])

export default __exports__